import styled, { css } from 'styled-components'

import AppButton from 'Components/AppButton'

import { FORM_BG_COLOR, CLICKABLE_COLOR, LINK_COLOR, SELECTED_ITEM_BG_COLOR } from '@CSSVars/colors'

export const _Title = styled.div`
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: 600;
`

export const _RoomsTable = styled.table`
  width: 100%;

  border: none;
  border-collapse: collapse;
  border-spacing: 0;
  position: relative;

  tbody, thead, th, tr, td {
    border: none;
    border-spacing: 0;
  }
  tr {
    text-align: left;
  }
  tbody tr {
    &:nth-child(odd) {
      background-color: ${({ listingIsLocked }) => (listingIsLocked ? 'initial' : FORM_BG_COLOR)};
    }
  }
  th {
    padding: 11px 16px;
    font-weight: 600;
    &:nth-child(3) {
      min-width: 100px;
    }
    span {
      font-weight: 600;
    }
  }
  td {
    padding: 13px 16px;

    div {
      line-height: 22px;
    }
    &:nth-child(3) {
      min-width: 100px;
    }
  }

  td.roomFeatures {
    line-height: 22px;
  }

  thead {
    tr {
      background-color: white;
    }
  }
`

export const _SizeHeader = styled.th`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const _LoginRequired = styled(AppButton)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
  z-index: 1;
`

export const _ShowMoreCta = styled.div`
  display: inline-block;
  margin-top: 20px;
  color: ${CLICKABLE_COLOR};
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  @media (hover: hover){
    &:hover{
      color:${LINK_COLOR};
      cursor: pointer;
    }
  }
  &:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
`
const roomFeatures = css`
  @media screen and (max-width: 767px) {
    display: none;
  }
`
export const _RoomFeaturesTh = styled.th`
  ${roomFeatures}
`

export const _RoomFeaturesTd = styled.td`
  ${roomFeatures}
`
